import * as React from "react";
const SvgScan = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, fill: "none", viewBox: "0 0 25 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.5 4v5h2V5h4V3h-5a1 1 0 0 0-1 1m18 5V4a1 1 0 0 0-1-1h-5v2h4v4zm-2 10h-4v2h5a1 1 0 0 0 1-1v-5h-2zm-10 2v-2h-4v-4h-2v5a1 1 0 0 0 1 1zm-7-10h20v2h-20z" }));
export default SvgScan;
